import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { MdLockOutline, MdSubdirectoryArrowRight, MdPermMedia} from "react-icons/md";
import Pagination from "react-js-pagination";
import PropTypes from 'prop-types';
import { Button, FormControl, Select, MenuItem, Dialog, DialogActions, DialogTitle  } from '@mui/material'
import { CgSearch } from 'react-icons/cg';
import { MdRemoveRedEye } from 'react-icons/md';
import { BiTimeFive } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


const useStyles = makeStyles((theme)=>({
  boardListBoxBlock:{
    maxWidth:'1280px',
    margin:'0 auto', 
    padding:'30px 0px 0px 0px',
    position:'relative',

    fontFamily:[
      'Noto Sans KR'
    ],
    [theme.breakpoints.down(1025)]: {
      padding:'30px 10px 0px 10px',
    },
  },
  writeBtnDiv:{
    position:'absolute',
    top:'0',
    right:'0',
    [theme.breakpoints.down(1025)]: {
      display:'none',
    },
  },
  writeBtnDivM:{
    display:'none',
    [theme.breakpoints.down(1025)]: {
      display:'block',
      paddingLeft: '10%',
      paddingRight: '10%',
      paddingTop: '10%',
    },
  },
  boardListBox: {
    maxWidth:'1280px',
    margin:'0 auto', 
    padding:'40px 0px 0px 0px',
    display: 'flex',
    flexDirection: 'column',
  },
  Titles: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: '2px solid #007235',
    borderBottom: '2px solid #CCCCCC',
    paddingTop: 12,
    paddingBottom: 12,

    [theme.breakpoints.down(1025)]: {
      borderBottom:'none',
      paddingTop: 0,
    },
  },
  TitlesItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 300,

    [theme.breakpoints.down(1025)]: {
      display:'none',
    },

  },
  boardItems: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  noItmebox: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 100,
    borderBottom: '2px solid #CCC',
  },
  searchForm:{
    marginTop: '50px',
    display:'flex',
    justifyContent: 'center',
  },
  search:{
    display:'flex',
    alignItems:'center'
  },
  inputSearch:{
    border:'1px solid #CCC',
    padding:'0 0 0 20px',
    width:'298px',
    height:'32px',
    '&:focus-within':{
        outline:'none'
    },
    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  btnSearch:{      
    width:'30px',
    height:'32px',
    background:'#007235',    
    [theme.breakpoints.down(1025)]: {
      padding: '0 5px'
    },
  },
  responsiveSearch:{
    width:'20px',
    height:'20px',
    color:'#fff',
  },
  innerClass: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '50px',
    listStyle: 'none',
    padding: 0,
  },
  itemClass: {
    display: 'inline-block',
    width: '36px',
    height: '30px',
    border: '1px solid #CCC',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1rem',
  },
  itemClassFirst: {
  },
  itemClassLast: {
  },
  linkClass: {
    textDecoration: 'none',
    fontSize: '0.8rem',
  },
  activeClass: {
    backgroundColor: '#007235'
  },
  activeLinkClass: {
    color: 'white',
  },

}));

const BoardType1 = ({
  data,
  maxWidth = 1000, 
  lines=10, 
  pages=5, 
  cateType, 
  getSearchItems,
  keyword,
  setKeyword,
  searchType,
  setSearchType,
  main
}) => {

  let navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [itemList, setItemList] = useState([])

  const userInfo = useSelector(state => state.user.userInfo);
  const login = useSelector(state => state.user.login);
  const theme = useTheme();
  let editTheme = {...theme, maxWidth}
  const classes = useStyles(editTheme);

  const searchTypeList = [
    {num: 0, name: '제목'},
    {num: 1, name: '내용'},
    {num: 2, name: '아이디'},
    {num: 3, name: '이름'},
  ]

  useEffect(() => {
    setItemList(data.slice((lines * page ) - lines, (lines * page )))
  }, [page, data])

  useEffect(() => {
    setPage(1)
  }, [cateType])


  const handlePageChange = (page) => {
    setPage(page);
  };

  const noItem = () => (<div className={classes.noItmebox}>
      <p>게시글이 없습니다</p>
    </div>)

  return (
    <div className={classes.boardListBoxBlock}>
      {main && (
        <div className={classes.writeBtnDiv}>
            {(cateType === 'notice' || cateType === 'fag') ? 
              userInfo['mb_level'] === 10 && (
              <Button 
                variant="contained"
                style={{
                  background:'#007235',
                  padding:'5px 20px',
                  borderRadius:'0',
                  fontFamily:[
                    'Noto Sans KR'
                  ],
                }}
                onClick={ () => {
                  if(!login) return alert('로그인후 이용 가능 합니다.')
                  navigate("/BoardWrite", {
                    state: { cateType: cateType, wrReply:''}
                  })
                }}
              >
                글쓰기
              </Button>
              ) : (
              <Button 
                variant="contained"
                style={{
                  background:'#007235',
                  padding:'5px 20px',
                  borderRadius:'0'
                }}
                onClick={ () => {
                  if(!login) return alert('로그인후 이용 가능 합니다.')
                  navigate("/BoardWrite", {
                    state: 
                    { 
                      cateType: cateType, 
                      wrReply:'',
                      wrNum: 0
                    }
                  })
                }}
              >
                글쓰기
              </Button>
              )}

        </div>
      )}
      
      <div className={classes.boardListBox}>
          <div className={classes.Titles}>
              <h1 className={classes.TitlesItem} style={{flex: 0.3}}>번호</h1>
              <h1 className={classes.TitlesItem} style={{flex: 1}}>제목</h1>
              <h1 className={classes.TitlesItem} style={{flex: 0.3}}>작성자</h1>
              <h1 className={classes.TitlesItem} style={{flex: 0.3}}>등록일</h1>
              <h1 className={classes.TitlesItem} style={{flex: 0.3}}>조회수</h1>
          </div>
          <div className={classes.boardItems}>
              {itemList.length > 0 ? 
                itemList.map((item) => 
                                <BorderItem 
                                    key={item['wr_id']}
                                    id={item['wr_id']} 
                                    num={item['wr_num']} 
                                    reply={item['wr_reply']} 
                                    comment={item['wr_comment']} 
                                    option={item['wr_option']} 
                                    subject={item['wr_subject']} 
                                    hits={item['wr_hit']} 
                                    username={item['wr_name']} 
                                    userid={item['mb_id']} 
                                    datetime={item['wr_datetime']} 
                                    file={item['wr_file']}
                                    level={item['mb_level']}
                                    cateType={cateType}
                                    userInfo={userInfo}
                                />) :  noItem()}
          </div>

          {main && (
          <div className={classes.writeBtnDivM}>
              {(cateType === 'notice' || cateType === 'fag') ? 
                userInfo['mb_level'] === 10 && (
                <Button 
                  variant="contained"
                  style={{
                    background:'#007235',
                    padding:'5px 20px',
                    borderRadius:'0',
                    width: '100%',
                  }}
                  onClick={ () => {
                    if(!login) return alert('로그인후 이용 가능 합니다.')
                    navigate("/BoardWrite", {
                      state: { cateType: cateType, wrReply:''}
                    })
                  }}
                >
                  글쓰기
                </Button>
                ) : (
                <Button 
                  variant="contained"
                  style={{
                    background:'#007235',
                    padding:'5px 20px',
                    borderRadius:'0',
                    width: '100%',
                  }}
                  onClick={ () => {
                    if(!login) return alert('로그인후 이용 가능 합니다.')
                    navigate("/BoardWrite", {
                      state: 
                      { 
                        cateType: cateType, 
                        wrReply:'',
                        wrNum: 0
                      }
                    })
                  }}
                >
                  글쓰기
                </Button>
                )}

          </div>
        )}


          {main && (
            <div className={classes.searchForm}>
              <div className={classes.search}>
                  <FormControl 
                    sx={{ m: 1 }} 
                    style={{ padding:'0'}}
                  >
                    <Select
                      labelId="select-small"
                      id="select-small"
                      inputProps={{ 
                        'aria-label': 'Without label',
                        sx: {
                          marginRight: '30px'
                        }
                       }}
                      value={searchType}
                      onChange={(e) => setSearchType(e.target.value)}
                      sx={{ 
                        padding:'0 10px 0 0', 
                        borderRadius:'0',
                        height: 30,
                        fontSize: 15,
                        fontFamily:[
                          'Noto Sans KR'
                        ],
                      }}
                    >
                      {searchTypeList.map((itm) => <MenuItem key={itm.num} value={itm.num}>{itm.name}</MenuItem>)}
                    </Select>
                  </FormControl>
                  <input 
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    className={classes.inputSearch} 
                    onKeyDown={(e) => {
                      if(e.key === 'Enter') {
                        setPage(1)
                        getSearchItems()
                      }
                    }}
                  />
                  <button 
                    className={classes.btnSearch}
                    onClick={() => {
                      setPage(1)
                      getSearchItems()
                    }}
                  >
                    <CgSearch className={classes.responsiveSearch}/>
                  </button>
              </div>
            </div>
          )}


          <Pagination
              activePage={page}
              itemsCountPerPage={lines}
              totalItemsCount={data.length}
              pageRangeDisplayed={pages}
              prevPageText={"‹"}
              nextPageText={"›"}
              onChange={handlePageChange}
              className={classes.navi}
              innerClass={classes.innerClass}    //안에?
              itemClass={classes.itemClass}      //아이템들?
              itemClassFirst={classes.itemClassFirst}    //first?
              itemClassLast={classes.itemClassLast}     // last
              linkClass={classes.linkClass}        // 아이템 링크
              activeClass={classes.activeClass}        // 현재페이지
              activeLinkClass={classes.activeLinkClass}     // 현제페이지 링크
          />
      </div>
    </div>
  )
    
  
}


const useStylesBoardItem = makeStyles((theme)=>({
  ItemBox: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottom: '2px solid #ccc',
    paddingTop: 12,
    paddingBottom: 12,
    color:'#555555',

    [theme.breakpoints.down(1025)]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  borderItemUp:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontSize:'14px',

    [theme.breakpoints.down(1025)]: {
      display:'none'
    },
  },
  borderItemDiv:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,


    [theme.breakpoints.down(1025)]: {
      justifyContent:'flex-start',
      marginLeft: 5,
    },

  },
  borderItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontSize:'14px',
    '&:first-child':{ 
      flex: 0.17
    },
    '&:nth-child(2)':{ 
      flex: 0.5
    },
    '&:last-child':{ 
      flex: 0.1
    },

    [theme.breakpoints.down(1025)]: {
      '&:first-child':{ 
        flex: 0.5
      },
      '&:nth-child(2)':{ 
        flex: 1
      },
      '&:last-child':{ 
        flex: 1,
      },
    },
  },
  subjectBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden',
    justifyContent:'center',

    [theme.breakpoints.down(1025)]: {
      justifyContent:'flex-start',
    },
  },
  ItemSubject: {
    marginLeft: 5,
    marginRight: 5,
    cursor: 'pointer',
    fontSize:'14px',

    [theme.breakpoints.down(1025)]: {
      
    }
  },
  timeIcon:{
    display:'none',

    [theme.breakpoints.down(1025)]: {
      display:'block',
      flex:'0.2',
      display:'flex',
      alignItems: 'center',
    }
  },
  eyeIcon:{
    display:'none',

    [theme.breakpoints.down(1025)]: {
      display:'block',
      flex:'0.2',
      display:'flex',
      alignItems: 'center',
    }
  },

}));

const BorderItem = ({
  id, 
  num, 
  reply, 
  comment, 
  option, 
  subject, 
  hits, 
  username, 
  userid, 
  datetime, 
  file, 
  level,
  cateType,
  userInfo}) => {

  const theme = useTheme();
  const classes = useStylesBoardItem(theme);
  let navigate = useNavigate();
  const [dialog, setDialog] = useState('');

  const onClickItem = () => {
    if (option === "secret" && userInfo['mb_level'] !== 10) {
      if(userInfo['mb_id'] !== userid) {
        return setDialog('접근권한이 없습니다.')
      }
    }
    navigate('/BoardLook', {
      state:{ id: id,  cateType: cateType}
    })
  }

  return (
    <div 
      className={classes.ItemBox}
    >
        <h1 className={classes.borderItemUp} style={{flex: 0.3}}>
          {num.toString().substr(1)}
        </h1>
        <div className={classes.subjectBox} style={{flex: 1}}>
          {reply === "A" && <MdSubdirectoryArrowRight size="15" />}
          <p className={classes.ItemSubject} style={{fontWeight: level === 10 ? 'bold' : 'normal'}} onClick={(() => onClickItem())}>
            {subject.length > 20 ? `${subject.substr(0, 20)}...` : subject}
          </p>
          {file > 0 && <MdPermMedia size="15" />}
          {option === "secret" && <MdLockOutline size="15" />}
          {comment > 0 && <p style={{color: '#007235', marginLeft: 5}}>({comment})</p>}
        </div>
        <div className={classes.borderItemDiv}>
          <h1 
            className={classes.borderItem} 
            style={{fontWeight: level === 10 ? 'bold' : 'normal'}}
          >
            {level === 10 ? '관리자' : userid}
          </h1>
          <h1 className={classes.borderItem} >
            <BiTimeFive className={classes.timeIcon}/>
            {datetime.substr(0, 10).replaceAll('-', '/')}
          </h1>
          <h1 className={classes.borderItem} >
            <MdRemoveRedEye className={classes.eyeIcon}/>
            {hits}
          </h1>
        </div>

        <Dialog
            open={dialog === '' ? false : true}
            onClose={() => setDialog('')}
        >
            <DialogTitle id="alert-dialog-title">
                {dialog}
            </DialogTitle>
            <DialogActions>
                <Button onClick={() => setDialog('')} autoFocus>
                    확인
                </Button>
            </DialogActions>
        </Dialog>
    </div>

  )
}


BoardType1.propTypes = {
    /**
     * 게시판 기본 컴포넌트
     */
     data : PropTypes.object.isRequired,
    /**
     * @description
     * 게시판에 들어갈 Objsect List 넣어주셈
     */
     maxWidth : PropTypes.number,
    /**
     * @description
     * 게시판 전체 넓이 
     * default = 1000
     */
     lines: PropTypes.number,
    /**
     * @description
    *  게시판 라인길이 설정 
    *  default = 10
    */
     page: PropTypes.number,
     /**
      * @description
     *  게시판 하단 보여줄 페이징수 설정 
     *  default = 10
     */
      enterLevel: PropTypes.number,
    /**
     * @description
     *  게시판 아이템 클릭했을때 들어갈수있는 최소레벨 
     *  default = 1
     */

};


export default BoardType1


